import { range } from "lodash"
import { Sprites } from "../../../utils/Sprites"
import { CampCravingsAssets } from "../CampCravingsAssets"
import { CampPos } from "../CampPos"

export enum PawnAnim {
    TO_BUS = "toBus",
    TO_LAKE = "toDock",
    TO_POST_LAKE = "toAfterLake",
    TO_PICNIC = "toPicnic",
    TO_PRE_NATURE_TRAIL = "toPreNatureTrail",
    TO_POST_NATURE_TRAIL = "toPostNatureTrail",
    TO_PRE_HORSES = "toPreHorses",
    TO_POST_HORSES = "toPostHorses",
    TO_LODGE = "toLodge",
    TO_FINISH = "toFinish"
}

export class PlayerPawn {
    sprite: Phaser.Sprite

    private constructor(
        private game: Phaser.Game,
        asset: string,
        x: number,
        y: number,
        private anims: Array<{ name: PawnAnim, start: number, end: number }>
    ) {

        this.sprite = Sprites.add(game, asset, {x, y})

        anims.forEach((anim) => {
            this.sprite.animations.add(anim.name, range(anim.start, anim.end))
        })
    }

    static round1NonUserPawn = (game: Phaser.Game) => {
        return new PlayerPawn(game, CampCravingsAssets.NON_USER_PAWN_ROUND_1, CampPos.pawnX(), CampPos.pawnY(),
            [
                {name: PawnAnim.TO_BUS, start: 1, end: 11},
                {name: PawnAnim.TO_LAKE, start: 12, end: 23},
                {name: PawnAnim.TO_POST_LAKE, start: 24, end: 48},
                {name: PawnAnim.TO_PRE_NATURE_TRAIL, start: 49, end: 68},
                {name: PawnAnim.TO_POST_NATURE_TRAIL, start: 69, end: 102},
                {name: PawnAnim.TO_PRE_HORSES, start: 103, end: 118},
                {name: PawnAnim.TO_POST_HORSES, start: 119, end: 165},
                {name: PawnAnim.TO_FINISH, start: 166, end: 190},
            ]
        )
    }

    static round1UserPawn = (game: Phaser.Game) => {
        return new PlayerPawn(game, CampCravingsAssets.USER_PAWN_ROUND_1, CampPos.userPawnX(), CampPos.pawnY(),
            [
                {name: PawnAnim.TO_BUS, start: 1, end: 11},
                {name: PawnAnim.TO_LAKE, start: 12, end: 23},
                {name: PawnAnim.TO_POST_LAKE, start: 24, end: 46},
                {name: PawnAnim.TO_PRE_NATURE_TRAIL, start: 47, end: 68},
                {name: PawnAnim.TO_POST_NATURE_TRAIL, start: 69, end: 88},
                {name: PawnAnim.TO_PRE_HORSES, start: 89, end: 104},
                {name: PawnAnim.TO_POST_HORSES, start: 105, end: 135},
            ]
        )
    }

    static round2NonUserPawn = (game: Phaser.Game) => {
        return new PlayerPawn(game, CampCravingsAssets.NON_USER_PAWN_ROUND_2, CampPos.pawnX(), CampPos.pawnRound2Y(),
            [
                {name: PawnAnim.TO_LAKE, start: 1, end: 10},
                {name: PawnAnim.TO_POST_LAKE, start: 11, end: 47},
                {name: PawnAnim.TO_PICNIC, start: 48, end: 59},
                {name: PawnAnim.TO_PRE_HORSES, start: 60, end: 93},
                {name: PawnAnim.TO_POST_HORSES, start: 94, end: 127},
                {name: PawnAnim.TO_LODGE, start: 128, end: 142},
                {name: PawnAnim.TO_FINISH, start: 143, end: 152},
            ]
        )
    }

    static round2UserPawn = (game: Phaser.Game) => {
        return new PlayerPawn(game, CampCravingsAssets.USER_PAWN_ROUND_2, CampPos.userPawnX(), CampPos.userPawnRound2Y(),
            [
                {name: PawnAnim.TO_LAKE, start: 1, end: 10},
                {name: PawnAnim.TO_POST_LAKE, start: 11, end: 47},
                {name: PawnAnim.TO_PICNIC, start: 48, end: 58},
                {name: PawnAnim.TO_PRE_HORSES, start: 59, end: 94},
                {name: PawnAnim.TO_POST_HORSES, start: 95, end: 124},
                {name: PawnAnim.TO_LODGE, start: 125, end: 140},
            ]
        )
    }

    playAnim = (anim: PawnAnim, onComplete?: () => void) => {
        this.sprite.animations.play(anim, 9)
        if (onComplete) {
            this.sprite.animations.currentAnim.onComplete.addOnce(onComplete)
        }
    }
}
